import Menu from '@mui/material/Menu';
import { BizIcon, TBizIcon } from './BizIcon';
import MenuItem from '@mui/material/MenuItem';
import './biz-context-menu.scss';
//import { useRef, useState } from 'react';

export type ContextMenuItem = {
	label: string;
	getLabel?: () => string;
	icon?: TBizIcon;
	systemName?: string;
	onClick: (item?: unknown) => void;
	hidden?: boolean;
	isHiddenFn?: (systemName?: string, item?: unknown) => boolean;
	divider?: boolean;
	cssClass?: string;
	//children?: ContextMenuItem[];
};

export type BizContextMenuConfig = {
	mouseX: number;
	mouseY: number;
	menuItems: ContextMenuItem[];
	element: unknown;
	onClose: () => void;
	cssClass?: string;
};

const BizContextMenu = ({ mouseX, mouseY, menuItems, element, onClose, cssClass }: BizContextMenuConfig) => {
	//tried adding support for submenus but it didn't work no matter what I fucking tried

	// const [submenuAnchorEl, setSubmenuAnchorEl] = useState<null | HTMLElement>(null);
	// const [submenuItems, setSubmenuItems] = useState<ContextMenuItem[] | null>(null);
	// const submenuTimeoutRef = useRef<NodeJS.Timeout | null>(null);

	// // Track hover status for parent and submenu
	// const isParentHoveredRef = useRef(false);
	// const isSubmenuHoveredRef = useRef(false);

	// const handleOpenSubmenu = (anchorElement: HTMLElement, children: ContextMenuItem[]) => {
	// 	if (submenuTimeoutRef.current) {
	// 		clearTimeout(submenuTimeoutRef.current);
	// 	}

	// 	setSubmenuAnchorEl(anchorElement);
	// 	setSubmenuItems(children);
	// };

	// const handleCloseSubmenu = () => {
	// 	if (submenuTimeoutRef.current) {
	// 		clearTimeout(submenuTimeoutRef.current);
	// 	}

	// 	submenuTimeoutRef.current = setTimeout(() => {
	// 		if (!isParentHoveredRef.current && !isSubmenuHoveredRef.current) {
	// 			setSubmenuAnchorEl(null);
	// 			setSubmenuItems(null);
	// 		}
	// 	}, 300); // Slight delay to avoid premature closing
	// };

	const filteredMenuItems = menuItems.filter((item) => {
		if (item.hidden === true) return false;
		if (item.isHiddenFn && item.isHiddenFn(item.systemName, element)) return false;
		return true;
	});

	const getLabel = (item: ContextMenuItem) => {
		if (item.getLabel) {
			return item.getLabel();
		}
		return item.label;
	};

	return (
		<>
			<Menu
				open={filteredMenuItems.length > 0}
				className={`biz-context-menu${cssClass ? ' ' + cssClass : ''}`}
				onClose={onClose}
				anchorReference='anchorPosition'
				anchorPosition={{ top: mouseY, left: mouseX }}
			>
				{filteredMenuItems.map((item, index) => {
					//const hasChildren = item.children && item.children.length > 0;
					return (
						<MenuItem
							className={`biz-context-menu-item${item.cssClass ? ' ' + item.cssClass : ''}`}
							divider={item.divider}
							key={index}
							onClick={() => {
								if (/*!hasChildren && */ item.onClick) {
									item.onClick(element);
									onClose();
								}
							}}
							// onMouseEnter={(event) => {
							// 	console.log('PARENT Mouse enter');
							// 	isParentHoveredRef.current = true;
							// 	if (hasChildren) {
							// 		handleOpenSubmenu(event.currentTarget as HTMLElement, item.children!);
							// 	}
							// }}
							// onMouseLeave={() => {
							// 	console.log('PARENT Mouse leave');
							// 	isParentHoveredRef.current = false;
							// 	if (hasChildren) {
							// 		handleCloseSubmenu();
							// 	}
							// }}
						>
							<div className='biz-icon-wrapper'>{item.icon !== undefined && <BizIcon icon={item.icon} />}</div>
							<span>{getLabel(item)}</span>
						</MenuItem>
					);
				})}
			</Menu>
			{/* {submenuItems !== null && (
				<Menu
					open={Boolean(submenuAnchorEl)}
					anchorEl={submenuAnchorEl}
					onClose={handleCloseSubmenu}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onMouseEnter={() => {
						console.log('SUBMENU Mouse enter');
						isSubmenuHoveredRef.current = true;
					}}
					onMouseLeave={() => {
						console.log('SUBMENU Mouse leave');
						isSubmenuHoveredRef.current = false;
						handleCloseSubmenu();
					}}
				>
					{submenuItems.map((subItem, subIndex) => (
						<MenuItem
							key={subIndex}
							onClick={() => {
								if (subItem.onClick) {
									subItem.onClick(element);
									onClose();
								}
								handleCloseSubmenu();
							}}
						>
							{subItem.icon && <BizIcon icon={subItem.icon} />}
							{subItem.label}
						</MenuItem>
					))}
				</Menu>
			)} */}
		</>
	);
};

export default BizContextMenu;
